export default __webpack_public_path__ + "static/media/GradientIndoorBottom.5e02df3a.svg";